import type { ReactNode } from 'react';

export interface DetailField {
    label: string;
    value: ReactNode;
}

interface Props {
    fields: DetailField[];
    /** Rendered instead of the list when every field's value is empty. */
    emptyMessage: string;
}

/** Small `<dl>` primitive shared by the customer / vehicle panels. A field
 *  whose value is null/undefined/empty-string is skipped entirely rather than
 *  rendered as a blank row. */
export function DetailList({ fields, emptyMessage }: Props) {
    const present = fields.filter(
        (field) => field.value !== null && field.value !== undefined && field.value !== '',
    );

    if (present.length === 0) {
        return <p className="text-sm text-mp-muted">{emptyMessage}</p>;
    }

    return (
        <dl className="grid grid-cols-1 gap-x-4 gap-y-2 sm:grid-cols-2">
            {present.map((field) => (
                <div key={field.label}>
                    <dt className="text-xs font-medium uppercase tracking-wide text-mp-muted">
                        {field.label}
                    </dt>
                    <dd className="text-sm text-mp-foreground">{field.value}</dd>
                </div>
            ))}
        </dl>
    );
}
